export enum ErrorMessages {
    NAME_EMPTY = i18next.t('enum.ErrorMessages.NAME_EMPTY'),
    EMAIL_EMPTY = i18next.t('enum.ErrorMessages.EMAIL_EMPTY'),
    EMAIL_FORMAT = i18next.t('enum.ErrorMessages.EMAIL_FORMAT'),
}

export const isNotEmpty = (value: string, emptyMessage: string): string | null => {
    return value.trim() === '' ? emptyMessage : null;
};

export const emailValidate = (
    value: string,
    errorMessage?: {
        empty: string;
        format: string;
    }
): string | null => {
    if (value.trim() === '') {
        return ErrorMessages.EMAIL_EMPTY;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return !emailRegex.test(value) ? ErrorMessages.EMAIL_FORMAT : null;
};
